import FuncionarioService from "@/services/FuncionarioService";
import LoginService from "@/services/LoginService";
import helper from "@/helper";
import store from "@/store";

export const actions = {
  cadastrarFuncionario: ({ commit, dispatch }) => {
    commit("setFuncionario", {
      nome: "",
      nome_abreviado: "",
      perfil_id: "",
      cpf_cnpj: "",
      rg: "",
      data_admissao: "",
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      uf: "",
      email: "",
      contato: "",
      password: "",
      password_confirmation: "",
      situacao: "",
      cargo_funcao: "",
      login: "",
    }),
      dispatch("setModalCadastroFuncionario", true);
  },
  listarFuncionarios: ({ commit }, data) => {
    commit("setOverlay", true);
    FuncionarioService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setFuncionarios", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  visualizarFuncionario: ({ commit, dispatch }, data) => {
    commit("setFuncionario", data);
    dispatch("setModalCadastroFuncionario", true);
  },
  salvarFuncionario: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    FuncionarioService.salvar(data)
      .then((res) => {
        commit("addFuncionario", res.data);
        commit("setFuncionario", res.data);
        dispatch("listarFuncionarios", { limite: 20, pagina: 1 });
        commit("setOverlay", false);
        commit("snackbarSuccess", "Funcionario cadastrado.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrado.");
      });
  },
  atualizarFuncionario: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    FuncionarioService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Funcionario atualizado.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirFuncionario: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    dispatch("setModalExcluirFuncionario", false);
    dispatch("setModalCadastroFuncionario", false);
    FuncionarioService.excluir(data.id)
      .then((res) => {
        commit("removeFuncionario", data);
        commit("setOverlay", false);
        commit("snackbarError", "Funcionario excluído.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir Funcionario.");
      });
  },
  setModalCadastroFuncionario: ({ commit }, status) => {
    commit("setModalCadastrarFuncionario", false);
    setTimeout(() => {
      commit("setModalCadastrarFuncionario", status);
    }, 100);
  },
  setModalExcluirFuncionario: ({ commit }, status) => {
    commit("setModalExcluirFuncionario", false);
    setTimeout(() => {
      commit("setModalExcluirFuncionario", status);
    }, 100);
  },
  atualizarSenhaFuncionario: ({ commit }, data) => {
    commit("setOverlay", true);
    FuncionarioService.atualizarSenha(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarSuccess", "Senha atualizada.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        commit("snackbarError", "Erro ao atualizar senha.");
      });
  },
  setModalPermissaoFuncionario: ({ commit }, status) => {
    commit("setModalPermissaoFuncionario", false);
    setTimeout(() => {
      commit("setModalPermissaoFuncionario", status);
    }, 100);
  },
  async solicitarPermissaoFuncionario({ commit, dispatch }, data) {
    commit("setOverlay", true);
    await LoginService.login(data)
      .then((res) => {
        commit("setOverlay", false);
        dispatch("setModalPermissaoFuncionario", false);
        if (helper.solicitarPermissao(res.data.user.perfil, data.permissao)) {
          dispatch(data.metodo);
          return true;
        } else {
          commit("snackbarError", "Este funcionário não permissão");
          return false;
        }
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Senha incorreta.");
        console.log(e);
        return false;
      });
  },
  setSalario({ commit }, payload) {
    commit("setSalario", payload);
  },
  setDependente({ commit }, payload) {
    commit("setDependente", payload);
  },
  setFuncionario({ commit }, payload) {
    commit("setFuncionario", payload);
  },
  listarSalarios({ commit }) {
    commit("setOverlay", true);
    FuncionarioService.listarSalarios(store.getters.getFuncionario.id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setSalarios", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro + " + e);
      });
  },
  listarDependentes({ commit }) {
    commit("setOverlay", true);
    FuncionarioService.listarDependentes(store.getters.getFuncionario.id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setDependentes", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro + " + e);
      });
  },
  cadastrarSalario({ commit }) {
    commit("setOverlay", true);
    FuncionarioService.cadastrarSalario({
      ...store.getters.getSalario,
      funcionario_id: store.getters.getFuncionario.id,
    })
      .then(() => {
        store.dispatch("listarSalarios");
        commit("setSalario", {});
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro + " + e);
      });
  },
  cadastrarDependente({ commit }) {
    commit("setOverlay", true);
    FuncionarioService.cadastrarDependente({
      ...store.getters.getDependente,
      funcionario_id: store.getters.getFuncionario.id,
    })
      .then(() => {
        store.dispatch("listarDependentes");
        commit("setDependente", {});
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro + " + e);
      });
  },
};

export default {};
